/*
SPDX-FileCopyrightText: 2024 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/

import { TolLoader } from "@tol/tol-ui";

interface Props {
  wording?: string;
}

function LoadingContent(props: Props) {
  const { wording } = props;
  return <TolLoader content={wording || "loading"} />;
}

export default LoadingContent;
